import { useGlobal } from '@/utils/useGlobal';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ProductNav from '../../common/ProductNav';
import { generalKey, productPageTheme, generalKeys } from '../../config/pageConfig';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { productDetailData } from '@/service';
import EfTab from 'elem/ui/ef-tab';
import getLocal from '@/app/utils/getLocal';
import styles from './index.module.scss';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}
export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = getLocal();
    const [spuId, setSpuId] = useState('');
    const [top, setTop] = useState(0);
    const [supportData, setSupportData] = useState(null);

    const [productPageData, setProductPageData] = useState({
        productCatagory: null,
        productSeries: [],
        supportDataArr: [],
    });

    useEffect(() => {
        const getProductSeriesData = async () => {
            const promiseAll = new Set();
            let proMsgAll: any[] = [];
            const productPageData = {
                productCatagory: null,
                productSeries: [],
                supportDataArr: [],
            };
            let len = 0;
            generalKeys?.map((item: GeneralKeyItemProps, _: number) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                // console.log('productMsg', productMsg);
                if (Object.keys(productMsg)?.length > 0) {
                    proMsgAll.push(productMsg);
                    promiseAll.add(productDetailData({ handle: item.url }, locale || 'us'));
                    len++;
                    promiseAll.add(getProductMsg(locale, productMsg));
                    len++;
                }
            });
            // promiseAll.add(productFaqBySpuId({ spuId: productMsg?.sourceId }, locale));

            try {
                const res: any = await Promise.all(promiseAll);
                console.log('res', res);
                if (proMsgAll?.length > 0 && len > 0 && res) {
                    for (let i = 0; i < len; i++) {
                        const flag1 = res[i] && res[i]?.code === '0';
                        const flag2 = res[i];
                        if (i % 2 === 0) {
                            if (flag1) {
                                if (i === 0) {
                                    productPageData.productCatagory = res[i]?.data?.productCatagoryResponseList;
                                }
                                productPageData.productSeries.push(res[i]?.data?.spuResponse);
                            }
                        } else {
                            if (flag2) {
                                productPageData.supportDataArr.push({
                                    supportData: res[i]?.supportData,
                                    prodectDetail: proMsgAll[(i - 1) / 2],
                                });
                            }
                        }
                    }
                    setProductPageData(productPageData);
                }
            } catch (e: any) {
                console.error('error', e);
            }
        };

        getProductSeriesData();
    }, []);

    const handleTabChange = (tab: any, k: number) => {
        setSpuId(tab?.type);
        setSupportData(productPageData?.supportDataArr[k]?.supportData);
    };

    const renderFrostNav = () => {
        let initScrollTop = 0;
        const regionPopupEl = document.querySelector('.regionPopup') as HTMLElement;
        if (regionPopupEl) {
            const styles = window.getComputedStyle(regionPopupEl);
            const position = styles.position;
            initScrollTop += Number(position === 'sticky' ? regionPopupEl?.offsetHeight : 0) || 0;
        }
        const headerEl = document.querySelector('.ecoflow-frame-header') as HTMLElement;
        if (headerEl) {
            const styles = window.getComputedStyle(headerEl);
            const position = styles.position;
            initScrollTop += Number(position === 'sticky' ? headerEl?.offsetHeight : 0) || 0;
        }
        const naverEl = document.querySelector('.ef-product-naver') as HTMLElement;
        if (naverEl) {
            const styles = window.getComputedStyle(naverEl);
            const position = styles.position;
            initScrollTop += Number(position === 'sticky' ? naverEl?.offsetHeight : 0) || 0;
        }
        setTop(initScrollTop);
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const tabWrapper = document.querySelector('.product-item-tab .tab-sticky-box') as HTMLElement;
        tabWrapper?.classList.toggle('frost', scrollTop > initScrollTop);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => {
        if (productPageData?.supportDataArr?.length > 0) {
            setSupportData(productPageData?.supportDataArr[0]?.supportData);
            setSpuId(productPageData?.supportDataArr[0]?.prodectDetail?.sourceId);
        }
    }, [productPageData?.supportDataArr]);
    return (
        <>
            <ProductNav activeTab={'Support'} />
            <div className={styles.support}>
                {productPageData?.supportDataArr?.length > 0 && (
                    <>
                        {productPageData?.supportDataArr?.length > 1 && (
                            <div className="tab-sticky-box" style={{ top: top + 'px' }}>
                                <div className="tab-wrapper">
                                    <EfTab
                                        items={productPageData?.supportDataArr?.map((data: any) => ({
                                            type: data?.prodectDetail?.sourceId,
                                            title: data?.prodectDetail?.name,
                                        }))}
                                        activeType={productPageData?.supportDataArr[0]?.prodectDetail?.sourceId}
                                        onChange={handleTabChange}
                                    />
                                </div>
                            </div>
                        )}
                        {supportData && <ProductSupport supportData={supportData} theme={'white'} spuId={spuId} />}
                    </>
                )}
            </div>
            {/* {productDataA.spuId && <ProductSupport supportData={productDataA.supportData} spuId={productDataA.spuId} theme={productPageTheme} />} */}
        </>
    );
}
